import React from 'react';

const EmptyReportsTable = () => (
  <div className="custom-reports-table-empty-state" >
    <p>You do not currently have any Apptopia-generated exports</p>
    <span>
      If you need help exporting complex data, please
      <a href="mailto:support@apptopia.com?subject=Request for Custom Reports data&body=Dear Customer Success, I am interested in getting customized data reports from Apptopia. I would like to discuss my requirements with you.">
        Email Customer Success
      </a>
    </span>
  </div>
);

export default EmptyReportsTable;
